// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import { gql } from '@apollo/client';

export const mutation = gql`
  mutation BulkInsertPipelines($pipelines: [pipelines_insert_input!]!) {
    insert_pipelines(objects: $pipelines) {
      returning {
        id
        name
        writekey
        clusterId
      }
    }
  }
`;

export function buildVariables(pipelines) {
  return {
    pipelines,
  };
}
